<!-- QUADRATO MAGICO-->
<div class="mt-3"></div>
<div id="quadrato_wrapper" class="" #quadratoWrapper [style.backgroundImage]="'url('+ config?.backgroundImage +')'" [style.backgroundSize]="'100%'">
  <div
    class="piece d-flex align-items-center justify-content-center"
    *ngFor="let piece of pieces"
    [style.width]="config.width + 'px'"
    [style.height]="config.height + 'px'"
    [style.top]="(piece.currentPosition.row * config.height)+ 'px'"
    [style.left]="(piece.currentPosition.col * config.width)+ 'px'"
    [style.opacity]="piece.id === 0 && !interaction.completed.onComplete ? 0 : 1"
    [style.backgroundImage]="'url('+ config.backgroundImage +')'"
    [style.backgroundPosition] = "((piece.finalPosition.col * config.width) * -1)+ 'px ' + ((piece.finalPosition.row * config.height) * -1)+ 'px'"
    [style.backgroundSize] = "(config.width * config.rows) + 'px'"
    (click)="movePiece(piece)"
  >
    <span class="text-white number" *ngIf="help">{{ piece.id }}</span>
  </div>
</div>
<div class="row mt-3" *ngIf="!interaction.completed.onComplete">
  <div class="col-6 text-center"><a href="javascript:;" class="btn btn-secondary text-dark" (click)="onHelp()">
    <span *ngIf="localStorage.getItem('l') === 'it'">Aiuto</span>
    <span *ngIf="localStorage.getItem('l') === 'en'">Help</span>
    <span *ngIf="localStorage.getItem('l') === 'fr'">Aide</span>
  </a></div>
  <div class="col-6 text-center"><a href="javascript:;" class="btn btn-secondary text-dark" (click)="onResolve()">
    <span *ngIf="localStorage.getItem('l') === 'it'">Risolvi</span>
    <span *ngIf="localStorage.getItem('l') === 'en'">Resolve</span>
    <span *ngIf="localStorage.getItem('l') === 'fr'">Résoudre</span>
  </a></div>
</div>
<!-- END OF QUADRATO MAGICO-->
